import locker_l_icon from "./files/locker_l_icon.svg";
import locker_l_illustration from "./files/locker_l_illustration.svg";
import locker_m_icon from "./files/locker_m_icon.svg";
import locker_m_illustration from "./files/locker_m_illustration.svg";
import locker_xl_icon from "./files/locker_xl_icon.svg";
import locker_xl_illustration from "./files/locker_xl_illustration.svg";
import logo_primary from "./files/logo_primary.svg";
import logo_primary_full from "./files/logo_primary_full.svg";
import pattern_primary from "./files/pattern_primary.png";

interface IImages {
  [key: string]: string;
  logo_primary: string;
  logo_primary_full: string;
  pattern_primary: string;
  locker_m_icon: string;
  locker_m_illustration: string;
  locker_l_icon: string;
  locker_l_illustration: string;
  locker_xl_icon: string;
  locker_xl_illustration: string;
}

export const images: IImages = {
  logo_primary: logo_primary,
  logo_primary_full: logo_primary_full,
  pattern_primary: pattern_primary,
  locker_m_icon: locker_m_icon,
  locker_m_illustration: locker_m_illustration,
  locker_l_icon: locker_l_icon,
  locker_l_illustration: locker_l_illustration,
  locker_xl_icon: locker_xl_icon,
  locker_xl_illustration: locker_xl_illustration,
};
